module.exports = __webpack_public_path__ + "media/comboSmash-preview@xs-89dd8297fc57fd3d5914199db53b22e2.jpg";